var img = "data:image/svg+xml,%3csvg width='100' height='46' viewBox='0 0 100 46' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='49' height='46' rx='2' fill='%233D424C'/%3e%3crect x='51' width='49' height='46' rx='2' fill='%233D424C'/%3e%3c/svg%3e";
  var TwoColumnsDevFilled = img;

export { TwoColumnsDevFilled as default };
